export default class GlobalState {
  private static instance: GlobalState;
  private states: Record<string, any>;

  static init() {
    if (!this.instance) {
      this.instance = new GlobalState();
    }
  }

  private constructor() {
    this.states = {};
  }

  static set(key: string, value: any) {
    this.instance.states[key] = value;
  }

  static get(key: string) {
    return this.instance.states[key];
  }

  static remove(key: string) {
    delete this.instance.states[key];
  }
}